/* Converto — analytics.js
   DataLayer GA4 : événements e-commerce standards, prêts pour GTM.
   Le thème pousse les événements ; les tags, le consentement (Consent Mode v2)
   et l'événement purchase (pixel Customer Events) se gèrent côté GTM/Shopify. */

(function () {
  // F07 : une page prérendue n'émet aucun événement ni effet avant son
  // activation réelle (les hits GA4 anticipés fausseraient la mesure)
  if (document.prerendering) {
    document.addEventListener('prerenderingchange', init, { once: true });
  } else {
    init();
  }
  function init() {
  if (window.Shopify?.designMode || window._convertoAnalyticsInitialized) return;
  const A = window.ConvertoAnalytics;
  if (!A) return;
  window._convertoAnalyticsInitialized = true;
  window.dataLayer = window.dataLayer || [];

  function push(eventName, ecommerce) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: eventName, ecommerce: Object.assign({ currency: A.currency }, ecommerce) });
  }

  function itemsValue(items) {
    return Math.round(items.reduce((sum, i) => sum + (i.price || 0) * (i.quantity || 1), 0) * 100) / 100;
  }

  /* ---------- Vues de pages ---------- */
  if (A.product) {
    // La variante réellement présélectionnée (carte d'offre « recommandée »)
    // peut différer de selected_or_first_available : on lit le formulaire
    try {
      const idInput = document.querySelector('.product-page form[action*="/cart/add"] [name="id"]');
      const vjson = document.querySelector('[data-product-json]');
      if (idInput && vjson) {
        const v = JSON.parse(vjson.textContent).find((x) => String(x.id) === String(idInput.value));
        if (v) {
          A.product.item_id = v.sku || v.id;
          A.product.item_variant = v.title;
          A.product.price = v.price / 100;
        }
      }
    } catch (e) { /* données initiales Liquid conservées */ }
    push('view_item', { value: A.product.price, items: [A.product] });
    // L'objet analytique suit la variante sélectionnée (add_to_cart cohérent)
    document.addEventListener('variant:changed', (e) => {
      const v = e.detail.variant;
      if (!v) return;
      A.product.item_id = v.sku || v.id;
      A.product.item_variant = v.title;
      A.product.price = v.price / 100;
    });
  }
  if (A.list) {
    // Les items réellement rendus dans la grille priment sur la liste Liquid
    // limitée à 12 : index réels, pagination comprise
    const rendered = Array.from(document.querySelectorAll('.collection-main .product-card[data-item-id]'))
      .map((card, i) => ({
        item_id: card.dataset.itemId,
        item_name: card.dataset.itemName,
        item_brand: card.dataset.itemBrand,
        item_variant: card.dataset.itemVariant || undefined,
        price: parseFloat(card.dataset.itemPrice) || 0,
        index: i + 1,
        quantity: 1
      }));
    push('view_item_list', {
      item_list_id: A.list.item_list_id,
      item_list_name: A.list.item_list_name,
      items: rendered.length ? rendered : A.list.items
    });
  }
  if (A.template === 'cart') {
    push('view_cart', { value: A.cart.value, items: A.cart.items });
  }

  /* ---------- Navigation vers une fiche produit (select_item) ---------- */
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.product-card');
    if (!card || !card.dataset.itemName) return;
    // Seule la navigation compte : pas l'ajout rapide ni un contrôle de la carte
    if (e.target.closest('button, product-form, [data-upsell-add], [data-routine-add]')) return;
    const link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    // L'achat rapide peut orienter ce lien vers une autre variante que la carte filtrée.
    const selection = link.hasAttribute('data-item-id') ? link.dataset : card.dataset;
    push('select_item', {
      item_list_id: A.list ? A.list.item_list_id : undefined,
      item_list_name: A.list ? A.list.item_list_name : undefined,
      items: [{
        item_id: selection.itemId,
        item_name: card.dataset.itemName,
        item_brand: card.dataset.itemBrand,
        item_variant: selection.itemVariant || undefined,
        price: parseFloat(selection.itemPrice) || 0,
        quantity: 1
      }]
    });
  });

  /* ---------- État panier et différences de lignes confirmées (F03) ---------- */
  function mapCartItem(i) {
    return {
      item_id: i.sku || i.variant_id,
      item_name: i.product_title || i.title,
      item_brand: i.vendor,
      item_variant: i.variant_title || undefined,
      price: (i.final_price != null ? i.final_price : i.price) / 100,
      quantity: i.quantity
    };
  }
  function acceptCart(cart) {
    if (cart?.items && Number.isFinite(cart.total_price)) {
      A.cart = { value: cart.total_price / 100, items: cart.items.map(mapCartItem) };
    }
    return A.cart;
  }
  function groupedLines(cart) {
    const groups = new Map();
    (cart?.items || []).forEach((line) => {
      const key = Converto.cart.variantFingerprint(line);
      const current = groups.get(key);
      if (current) current.quantity += line.quantity;
      else groups.set(key, mapCartItem(line));
    });
    return groups;
  }
  function trackDifference(before, after, addedOnly = false) {
    const previous = groupedLines(before), next = groupedLines(after);
    const added = [], removed = [];
    new Set([...previous.keys(), ...next.keys()]).forEach((key) => {
      const p = previous.get(key), n = next.get(key);
      const delta = (n?.quantity || 0) - (p?.quantity || 0);
      if (delta > 0) added.push(Object.assign({}, n, { quantity: delta }));
      if (delta < 0) removed.push(Object.assign({}, p, { quantity: -delta }));
    });
    if (removed.length && !addedOnly) push('remove_from_cart', { value: itemsValue(removed), items: removed });
    if (added.length) push('add_to_cart', { value: itemsValue(added), items: added });
  }
  document.addEventListener('cart:state', (event) => acceptCart(event.detail.cart));
  document.addEventListener('cart:added', (event) => {
    const data = event.detail || {};
    if (data.cart && data.previousCart) trackDifference(data.previousCart, data.cart, true);
    else {
      // Une lecture complète peut échouer après un ajout confirmé. Ne pas
      // confondre quantité cumulée de la réponse et quantité réellement ajoutée.
      const previous = groupedLines(data.previousCart);
      const requested = new Map();
      (data.requestedItems || []).forEach((item) => {
        const key = Converto.cart.variantFingerprint({ variant_id: Number(item.id), properties: item.properties,
          selling_plan_allocation: { selling_plan: { id: item.selling_plan } } });
        requested.set(key, (requested.get(key) || 0) + Number(item.quantity || 1));
      });
      const items = (data.items || (data.id ? [data] : [])).map((line) => {
        const key = Converto.cart.variantFingerprint(line);
        const knownQuantity = previous.get(key)?.quantity || 0;
        const quantity = data.previousCart ? line.quantity - knownQuantity
          : requested.has(key) ? Math.min(line.quantity, requested.get(key)) : line.quantity;
        return Object.assign(mapCartItem(line), { quantity });
      }).filter((item) => item.quantity > 0);
      if (items.length) push('add_to_cart', { value: itemsValue(items), items });
    }
    if (data.cart) acceptCart(data.cart);
    else refreshCartState();
  });
  document.addEventListener('cart:updated', (event) => {
    const data = event.detail || {};
    const cart = data.cart || (Number.isFinite(data.total_price) ? data : null);
    if (cart && data.previousCart) trackDifference(data.previousCart, cart);
    if (cart) acceptCart(cart);
    else refreshCartState();
  });
  async function refreshCartState() {
    try { return acceptCart(await Converto.cart.getState()); }
    catch (err) { return A.cart; }
  }
  // analytics.js peut être activé après le chargement (page prérendue).
  if (window.Converto?.cart?.state) acceptCart(Converto.cart.state);

  /* ---------- Ouverture du tiroir panier (view_cart) ----------
     Centralisé sur Converto.drawer.open : couvre le clic ET l'ouverture
     automatique après ajout, avec déduplication (une vue par ouverture). */
  let lastViewCart = 0;
  async function pushViewCart() {
    if (Date.now() - lastViewCart < 2000) return;
    lastViewCart = Date.now();
    const cart = await refreshCartState();
    if (cart) push('view_cart', { value: cart.value, items: cart.items });
  }
  if (window.Converto && Converto.drawer && typeof Converto.drawer.open === 'function') {
    const origOpen = Converto.drawer.open.bind(Converto.drawer);
    Converto.drawer.open = function (id) {
      origOpen(id);
      if (id === 'cart-drawer-wrapper' && document.getElementById(id)?.classList.contains('is-open')) pushViewCart();
    };
  }

  /* ---------- Passage au checkout ---------- */
  document.addEventListener('click', (e) => {
    const checkoutBtn = e.target.closest('[name="checkout"]');
    if (!checkoutBtn) return;
    // Push synchrone (la page va décharger) avec l'état maintenu à jour ci-dessus ;
    // le pixel Shopify côté checkout reste la source fiable en dernier ressort.
    push('begin_checkout', { value: A.cart.value, items: A.cart.items });
  });

  /* ---------- Recherche ---------- */
  if (A.search_terms) {
    window.dataLayer.push({ event: 'search', search_term: A.search_terms });
  }

  /* F06 : les observations suivent les éléments des sections injectées. */
  const observers = new Map();
  const observedPromotions = new WeakSet();
  function watchVisibility(element, callback) {
    if (observers.has(element)) return;
    const check = () => {
      if (element.hidden || !element.isConnected) return;
      callback(); observer.disconnect(); observers.delete(element);
    };
    const observer = new MutationObserver(check);
    observers.set(element, observer);
    observer.observe(element, { attributes: true, attributeFilter: ['hidden'] });
    check();
  }
  function observePromotions(root) {
    root.querySelectorAll('converto-popup').forEach(popup => {
      if (observedPromotions.has(popup)) return;
      watchVisibility(popup, () => {
        observedPromotions.add(popup);
        window.dataLayer.push({ event: 'view_promotion', ecommerce: { promotion_id: popup.dataset.key || popup.id, promotion_name: popup.dataset.promoName || 'popup' } });
      });
    });
  }
  observePromotions(document);
  document.addEventListener('shopify:section:load', event => observePromotions(event.target));
  document.addEventListener('shopify:section:unload', event => {
    observers.forEach((observer, element) => {
      if (!element.isConnected || event.target.contains(element)) { observer.disconnect(); observers.delete(element); }
    });
  });

  /* G08 : identifiants harmonisés entre affichage (view_promotion), clic du
     CTA et copie de code : la clé du popup prime, sinon l'id stable du bloc. */
  function promoIdentity(el) {
    const popup = el.closest('converto-popup');
    if (popup) {
      return { promotion_id: popup.dataset.key || popup.id, promotion_name: popup.dataset.promoName || 'popup' };
    }
    return { promotion_id: el.dataset.promoId || el.dataset.copyCode || el.id || 'promo', promotion_name: el.dataset.promoName || 'code_promo' };
  }
  document.addEventListener('click', (e) => {
    const code = e.target.closest('[data-copy-code]');
    if (code) {
      window.dataLayer.push({ event: 'select_promotion', ecommerce: promoIdentity(code) });
      return;
    }
    // CTA d'un popup promotionnel (lien ou bouton d'action, hors fermeture)
    const cta = e.target.closest('converto-popup a, converto-popup button[type="submit"]');
    if (cta && !cta.closest('[data-popup-close]')) {
      window.dataLayer.push({ event: 'select_promotion', ecommerce: promoIdentity(cta) });
    }
  });

  /* ---------- G07 : interactions CRO nommées, activation par famille ----------
     IDs stables (section/bloc), aucune valeur libre saisie par le visiteur. */
  const cro = A.cro || {};
  function sectionIdOf(el) {
    const s = el.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : undefined;
  }
  function pushCro(type, el, value) {
    window.dataLayer.push({ event: 'cro_interaction', cro_type: type, cro_section: el ? sectionIdOf(el) : undefined, cro_value: value });
  }

  if (cro.commerce) {
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (t.name === 'qb-offer') pushCro('tier_select', t, t.value);
      else if (t.name === 'offer-variant') pushCro('offer_select', t, t.value);
      else if (t.name === 'selling_plan') pushCro('plan_select', t, t.value || 'one_time');
      else if (t.type === 'checkbox' && t.closest('goal-multiselect')) pushCro('goal_select', t, t.checked ? 'check' : 'uncheck');
      else if (t.type === 'checkbox' && t.name === 'addon-variant') pushCro('upsell_select', t, t.checked ? 'check' : 'uncheck');
    });
    document.addEventListener('click', (e) => {
      const bundle = e.target.closest('[data-bundle-add]');
      if (bundle) pushCro('bundle_add', bundle);
      const goal = e.target.closest('[data-goal-add]');
      if (goal) pushCro('goal_add', goal);
      const routine = e.target.closest('[data-routine-add]');
      if (routine) pushCro('routine_add', routine);
    });
  }

  if (cro.filters) {
    // Les facettes se soumettent au changement (submit programmatique : pas
    // d'événement submit) : on pousse le nom du paramètre, jamais sa saisie
    document.addEventListener('change', (e) => {
      const facet = e.target.closest('#facets-form, .facets');
      if (facet && e.target.name) pushCro('filter_apply', e.target, e.target.name);
    });
  }

  if (cro.media) {
    document.addEventListener('click', (e) => {
      const card = e.target.closest('.video-card');
      if (card && card.querySelector('video') && !card._croPlayed) {
        card._croPlayed = true;
        pushCro('video_play', card, 'ugc');
      }
      const story = e.target.closest('[data-story-open]');
      if (story) pushCro('video_play', story, 'story');
    });
  }

  /* G08 : inscription réussie mesurée séparément du simple clic */
  if (cro.signup !== false) {
    const pushSignup = (el) => {
      const id = sectionIdOf(el) || 'newsletter';
      try {
        if (sessionStorage.getItem('converto-signup-' + id)) return;
        sessionStorage.setItem('converto-signup-' + id, '1');
      } catch (err) { /* navigation privée : on pousse quand même */ }
      window.dataLayer.push({ event: 'sign_up', method: 'newsletter', cro_section: id });
    };
    const observeSignup = root => root.querySelectorAll('[data-newsletter-success]').forEach(el => {
      watchVisibility(el, () => pushSignup(el));
    });
    observeSignup(document);
    document.addEventListener('shopify:section:load', event => observeSignup(event.target));

  }
}
})();
